import { Page } from "@/models/page-models/Page";

export const PurchaseOrderAccounts: Page = {
  "path": "purchase-order-accounts",
  "name": "Purchase Orders",
  "props": {
    "data": {
      "title": "Purchase Orders",
      "printable": "FALSE",
      "url": "purchase-order-accounts",
      "groups": [
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "SUBMITTED",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.submitted.data}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "variable": "formData.submittedPOTable",
                      "label": "SUBMITTED",
                      "disabled": "FALSE",
                      "items": "fetchedData.submitted.data",
                      "tableType": "static",
                      "showActions": true,
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "PO #",
                          "width": 100
                        },
                        {
                          "value": "__item.actions",
                          "text": "Actions",
                          "type": "actions",
                          "actions": [
                            {
                              "label": "Edit",
                              "onClick": [
                                {
                                  "executionOrder": 1,
                                  "name": "openEditPO"
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "value": "__item.supplier.name",
                          "text": "Supplier Name"
                        },
                        {
                          "value": "__item.purchasedRMs",
                          "text": "RM Name",
                          "formula": "fn(HELPER_FN,goodsName,{{__item.rawMaterial}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.unitQuantity",
                          "text": "Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,{{__item.unitQuantity}} {{__item.rawMaterial.rawMaterialUnit}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.price",
                          "text": "Price",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,{{{{__item.unitQuantity}}*{{__item.unitPrice}}}},{{__item.currencyCode}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.unitPrice",
                          "text": "Unit Price",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,{{__item.unitPrice}},{{__item.currencyCode}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.createdAt",
                          "text": "Date Submitted",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "APPROVED",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.approved.data}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "variable": "formData.approvedPOTable",
                      "label": "APPROVED",
                      "disabled": "FALSE",
                      "items": "fetchedData.approved.data",
                      "tableType": "static",
                      "showActions": true,
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "PO #",
                          "width": 100
                        },
                        {
                          "value": "__item.actions",
                          "text": "Actions",
                          "type": "actions",
                          "actions": [
                            {
                              "label": "Edit",
                              "onClick": [
                                {
                                  "executionOrder": 1,
                                  "name": "openEditPO"
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "value": "__item.supplier.name",
                          "text": "Supplier Name"
                        },
                        {
                          "value": "__item.purchasedRMs",
                          "text": "RM Name",
                          "formula": "fn(HELPER_FN,goodsName,{{__item.rawMaterial}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.unitQuantity",
                          "text": "Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,{{__item.unitQuantity}} {{__item.rawMaterial.rawMaterialUnit}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.price",
                          "text": "Price",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,{{{{__item.unitQuantity}}*{{__item.unitPrice}}}},{{__item.currencyCode}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.unitPrice",
                          "text": "Unit Price",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,{{__item.unitPrice}},{{__item.currencyCode}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.approvedAt",
                          "text": "Date Approved",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.approvedAt}})"
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "RECEIVED",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.recieved.data}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "variable": "formData.revceivedPOTable",
                      "label": "RECEIVED",
                      "disabled": "FALSE",
                      "items": "fetchedData.recieved.data",
                      "tableType": "static",
                      "showActions": false,
                      "onRowClick": {
                        "type": "url",
                        "value": "/add-purchase-order/__item._id"
                      },
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "PO #",
                          "width": 100
                        },
                        {
                          "value": "__item.actions",
                          "text": "Actions",
                          "type": "actions",
                          "actions": [
                            {
                              "label": "Edit",
                              "onClick": [
                                {
                                  "executionOrder": 1,
                                  "name": "openEditPO"
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "value": "__item.supplier.name",
                          "text": "Supplier Name"
                        },
                        {
                          "value": "__item.purchasedRMs",
                          "text": "RM Name",
                          "formula": "fn(HELPER_FN,goodsName,{{__item.rawMaterial}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.unitQuantity",
                          "text": "Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,{{__item.unitQuantity}} {{__item.rawMaterial.rawMaterialUnit}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.price",
                          "text": "Price",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,{{{{__item.unitQuantity}}*{{__item.unitPrice}}}},{{__item.currencyCode}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.unitPrice",
                          "text": "Unit Price",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,{{__item.unitPrice}},{{__item.currencyCode}})",
                          "multipleItemsVariable": "purchasedRMs"
                        },
                        {
                          "value": "__item.receivedAt",
                          "text": "Date Received",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.receivedAt}})"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getSubmittedPOs"
      },
      {
        "executionOrder": 1,
        "name": "getApprovedPOs"
      },
      {
        "executionOrder": 1,
        "name": "getRecievedPOs"
      }
    ],
    "functions": [
      {
        "name": "getSubmittedPOs",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/purchaseorder/submitted",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.submitted"
      },
      {
        "name": "getApprovedPOs",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/purchaseorder/approved",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.approved"
      },
      {
        "name": "getRecievedPOs",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/purchaseorder/received",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.recieved"
      },
      {
        "name": "openEditPO",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/edit-purchase-order/{{__item._id}}"
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE",
  "visible": false
}